export const GET_STUDENT_VISIBLE_INTERACTIONS = 'GET_STUDENT_VISIBLE_INTERACTIONS'
export const GET_STUDENT_COURSE_DESCRIPTION = 'GET_STUDENT_COURSE_DESCRIPTION'
export const GET_STUDENT_AGE = 'GET_STUDENT_AGE'
export const GET_ALL_VISIBLE_INTERVENTIONS = 'GET_ALL_VISIBLE_INTERVENTIONS'
export const GET_STUDENT_CALENDAR_INFO_BY_DATE = 'GET_STUDENT_CALENDAR_INFO_BY_DATE'
export const GET_STUDENT_GRAPH_INTERACTIONS = 'GET_STUDENT_GRAPH_INTERACTIONS'

// Admin specific
export const GET_ADMIN_ALERT_EMAILS = 'GET_ADMIN_ALERT_EMAILS'

// Profile specific
export const IS_ADMIN = 'IS_ADMIN'
export const IS_STUDENT = 'IS_STUDENT'
export const IS_STAFF = 'IS_STAFF'
export const IS_TUTOR = 'IS_TUTOR'
export const USER_NAME = 'USER_NAME'
export const HAS_FEATURE_FLAG = 'HAS_FEATURE_FLAG'

// Hierarchy specific
export const GET_HIERARCHY_CLASS_IDS = 'GET_HIERARCHY_CLASS_IDS'
export const GET_ALERT = 'GET_ALERT'

// Information
export const FROM_INTERACTIONS_LIST = 'FROM_INTERACTIONS'

// Intervention specific
export const GET_SELECTED_REFERRAL_OBJECT = 'GET_SELECTED_REFERRAL_OBJECT'

// Announcements specific
export const GET_ANNOUNCEMENTS_SEVERITY = 'GET_ANNOUNCEMENTS_SEVERITY'
export const GET_EDIT_ANNOUNCEMENT_ROLE_ARRAY = 'GET_EDIT_ANNOUNCEMENT_ROLE_ARRAY'
export const GET_ANNOUNCEMENT_DIALOG_STATE = 'GET_ANNOUNCEMENT_DIALOG_STATE'

export const GET_STUDENT_TRUNCATION_SIZE = 'GET_STUDENT_TRUNCATION_SIZE'
export const GET_STUDENT_TRUNCATION_TYPE = 'GET_STUDENT_TRUNCATION_TYPE'



// WEBPACK FOOTER //
// ./src/store/getter-types.js